// Copyright ©️ 2026 eVolve MEP, LLC

/**
 * The four steps of the Bend Creator, in order. Names and guidance come from the v15 prototype. `buttonName` is the
 * name in sentence case, for button labels such as "Next: Bend type".
 */
export const bendCreatorSteps = [
  { name: 'Material', buttonName: 'Material', guidance: 'Pick what is on the rack.' },
  { name: 'Bend Type', buttonName: 'Bend type', guidance: 'The shape of the part. The model updates as you pick.' },
  {
    name: 'Dimensions',
    buttonName: 'Dimensions',
    guidance: 'Runs are measured centre-to-centre. The model highlights what you are editing.',
  },
  { name: 'Review', buttonName: 'Review', guidance: 'Name it, set the quantity, then add it to the bend list.' },
] as const;

export type BendCreatorStepIndex = 0 | 1 | 2 | 3;

export const MATERIAL_STEP = 0;
export const BEND_TYPE_STEP = 1;
export const DIMENSIONS_STEP = 2;
export const REVIEW_STEP = 3;

export const bendCreatorStepIndexes: readonly BendCreatorStepIndex[] = [
  MATERIAL_STEP,
  BEND_TYPE_STEP,
  DIMENSIONS_STEP,
  REVIEW_STEP,
];

/** The step after each step, or null after the last one. */
export const nextStepOf: Record<BendCreatorStepIndex, BendCreatorStepIndex | null> = {
  [MATERIAL_STEP]: BEND_TYPE_STEP,
  [BEND_TYPE_STEP]: DIMENSIONS_STEP,
  [DIMENSIONS_STEP]: REVIEW_STEP,
  [REVIEW_STEP]: null,
};
